import { call, put, takeEvery, fork, all } from 'redux-saga/effects';
import axios from 'axios';



function * indexInvoicesAsync(data){
  try{
     const api = yield call([axios, axios.get], '/api/invoices')
     yield put({type:'REQUEST_INDEX_INVOICES_SUCCESS', val:api.data})
   }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * indexCreditConsumption(data){
  try{
     const api = yield call([axios, axios.get], '/api/credits_consumption?user_workspace_id='+data.user_workspace_id+'&back='+data.dates_back+'&time_frame='+data.time_frame)
     yield put({type:'REQUEST_INDEX_CREDIT_CONSUMPTION_SUCCESS', val:api.data});
   }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function* Index_invoices(){yield takeEvery('REQUEST_INDEX_INVOICES', indexInvoicesAsync);}
function* Index_credit_consumption(){yield takeEvery('REQUEST_INDEX_CREDIT_CONSUMPTION', indexCreditConsumption)}


export default function* Root_payments(){
  yield all([
    fork(Index_invoices),
    fork(Index_credit_consumption)
  ])}
